import React, { useEffect, useState } from "react";
import Section1 from "../../components/Allcontent/Section1";
import editorialservices from "../../json/Allservices/Editorialoffice.json";
import copyediting from "../../json/Allservices/Copyediting.json";
import projectmanagement from "../../json/Allservices/Projectmanagement.json";
import journalproduction from "../../json/Allservices/Journalproduction.json";
import bookproduction from "../../json/Allservices/Bookproduction.json";
import graphics from "../../json/Allservices/Graphics.json";
import peerreview from "../../json/Allservices/Peerreview.json";
import Ebooks from "../../json/Allservices/Ebooks.json";
import Accessibility from "../../json/Allservices/Accessibility.json";
import contentdigitization from "../../json/Allservices/Contentdigitization.json";
import contenttransformation from "../../json/Allservices/Contenttransformation.json";
import contentConversion from "../../json/Allservices/Contentconversion.json";
import healthops from "../../json/Allservices/Healthops.json";
import { useLocation, useParams } from "react-router-dom";
import Section2 from "../../components/Alldigital/digiSection2";
import Section3 from "../../components/Allcontent/Section3";
import Section4 from "../../components/Allcontent/Section4";
import Section5 from "../../components/Allcontent/Section5";
import Sections2 from "../../components/Allcontent/Section2";
import SEO from "../../components/SEO";

// const peerReviewSchema = {
//   "@context": "https://schema.org",
//   "@type": "Service",
//   name: "Peer Review Services",
//   provider: {
//     "@type": "Organization",
//     name: "Transforma Pvt Ltd",
//     url: "https://www.transforma.in/content/peerreview",
//   },
//   description:
//     "Comprehensive peer review services including expert reviewer matching, manuscript evaluation, real-time tracking, AI-driven reviewer assignment, and quality assurance for scholarly publications.",
// };
const seoSchemas = {
  peerreview: {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Peer Review Services",
    provider: {
      "@type": "Organization",
      name: "Transforma Pvt Ltd",
      url: "https://www.transforma.in/content/peerreview",
    },
    keywords: "peer review services, manuscript review, scholarly peer review, reviewer matching, XPERT Review, academic publishing, editorial review process, research publication support",
    description:
      "Comprehensive peer review services including expert reviewer matching, manuscript evaluation, real-time tracking, AI-driven reviewer assignment, and quality assurance for scholarly publications.",
  },

  copyediting: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Copy Editing Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/content/copyediting",
  },
  description:
    "Transforma delivers exceptional copy editing services through VEDAS and EditLaTeX platforms. We ensure professional language checks, styling expertise (APA, AMA, Chicago), and publication-ready manuscripts.",
  keywords:
    "copy editing services, VEDAS editing platform, EditLaTeX, manuscript language polish, editorial styling expertise, APA style editing, AMA style guide, scholarly copyediting, professional text editing",
},

journalproduction: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Journal Production Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/content/journalproduction",
  },
  description:
    "Fast, efficient, and high-quality journal production services using an XML-First typesetting workflow, VEDAS, and EditLaTeX. We guarantee seamless production and deliver first proofs within 24 hours.",
  keywords:
    "journal production services, XML-First typesetting, VEDAS platform, EditLaTeX, academic journal publishing, 24-hour first proofs, multi-format delivery, XML PDF EPUB, scholarly publication workflow, automated manuscript processing",
},

graphics: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Graphic and Multimedia Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/content/graphics",
  },
  description:
    "Comprehensive graphic and multimedia services by Transforma. We deliver high-quality image enhancement, artwork creation, layout design, infographics, custom illustrations, and professional audio/video production.",
  keywords:
    "graphic services, multimedia production, image enhancement, artwork creation, layout and design, infographics, data visualization, custom illustrations, professional audio production, video production services, scholarly publication graphics",
},

  editorialoffice: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Editorial Office Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/content/editorialoffice",
  },
  description:
    "Efficient editorial office management by Transforma. We streamline journal publishing workflows, handling manuscript submissions, peer review coordination, editorial board support, and compliance with ethical publishing standards.",
  keywords:
    "editorial office services, manuscript submission management, peer review coordination, editorial workflow automation, journal publishing support, editorial board assistance, manuscript tracking, ethical publishing compliance, publishing production coordination",
},

projectmanagement: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Project Management Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/content/projectmanagement",
  },
  description:
    "Expert project management services by Transforma for seamless journal and book production. We ensure a smooth publishing process with customized workflows, comprehensive stakeholder coordination, rigorous quality assurance, and timely delivery.",
  keywords:
    "project management services, journal production management, book production coordination, publishing workflow solutions, comprehensive coordination, quality assurance in publishing, scalable publishing solutions, manuscript to publication management",
},

bookproduction: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Book Production Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/content/bookproduction",
  },
  description:
    "Comprehensive book production services by Transforma. We streamline the entire publishing process, offering expert copy editing, project management, precision indexing, typesetting, layout design, and XML digital conversion.",
  keywords:
    "book production services, manuscript layout design, professional copy editing, book project management, precision indexing, advanced typesetting, artwork image handling, XML-first workflow, EPUB conversion, digital book publishing",
},

contenttransformation: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Content Transformation Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/content/contenttransformation",
  },
  description:
    "End-to-end content transformation services by Transforma. We reshape, optimize, and seamlessly convert content across various formats for diverse digital platforms while ensuring automation-driven efficiency and consistency.",
  keywords:
    "content transformation services, digital content conversion, cross-platform media optimization, automated publishing workflow, format restructuring solutions, scalable content solutions, digital age publishing",
},

ebooks: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "eBook Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/digital/ebooks",
  },
  description:
    "High-quality eBook services by Transforma. We transform manuscripts into polished digital publications, offering end-to-end solutions for eBook formatting, multi-platform conversion (EPUB, MOBI, PDF), interactive features, layout design, and distribution support.",
  keywords:
    "eBook services, eBook formatting, manuscript to digital conversion, EPUB MOBI production, interactive eBook features, digital book layout design, eBook distribution support, metadata and ISBN management, Amazon Kindle publishing, digital publishing quality assurance",
},

contentconversion: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Content Conversion Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/digital/contentconversion",
  },
  description:
    "Professional content conversion services by Transforma. We efficiently transform data with precision and accessibility, offering format conversion (PDF to Word, Excel to XML), custom data processing, database conversion from legacy systems, data migration, and rigorous quality assurance.",
  keywords:
    "content conversion services, data format conversion, legacy database conversion, data migration solutions, custom data processing, data formatting and structuring, PDF to Word conversion, Excel to XML, enterprise data transformation, data quality assurance",
},

accessibility: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Accessibility Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/digital/accessibility",
  },
  description:
    "Comprehensive accessibility services by Transforma to create inclusive digital experiences. Leveraging expert Benetech validation, we ensure full compliance with WCAG and Section 508 guidelines through thorough accessibility audits, screen reader compatibility, accurate captioning, and keyboard-only navigation.",
  keywords:
    "accessibility services, digital accessibility solutions, Benetech validation, WCAG compliance, Section 508 auditing, screen reader compatibility, alt text image optimization, video captioning services, audio transcription, keyboard-only navigation",
},

healthops: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "HealthOps Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/digital/healthops",
  },
  description:
    "Comprehensive Medical Billing, Coding, and Pharmaceutical Data Services by Transforma. We streamline healthcare processes and optimize revenue cycle management through expert ICD, CPT, and HCPCS medical coding, claims management, clinical trial data compliance, and advanced analytics.",
  keywords:
    "HealthOps services, medical billing solutions, certified medical coding, pharmaceutical data management, revenue cycle management, ICD CPT coding systems, healthcare claims processing, clinical trial data analysis, healthcare regulatory compliance, medical billing analytics",
},

contentdigitization: {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Content Digitization Services",
  provider: {
    "@type": "Organization",
    name: "Transforma Pvt Ltd",
    url: "https://www.transforma.in/digital/contentdigitization",
  },
  description:
    "Comprehensive content digitization services by Transforma. We accurately convert physical documents, books, and archival materials into efficient digital assets using high-quality document scanning, Optical Character Recognition (OCR), metadata indexing, and secure digital archiving.",
  keywords:
    "content digitization services, document scanning solutions, OCR text conversion, optical character recognition, data indexing and tagging, digital archiving services, archival material preservation, metadata tag optimization, physical to digital document conversion, high-quality scanning technologies",
},

  // add remaining services same way...
};

const AllContent = () => {
  const { services } = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const [data, setData] = useState("");

  useEffect(() => {
    setdata(services);
  }, [services]);

  const setdata = (services) => {
    switch (services) {
      case "editorialoffice":
        return setData(editorialservices);
      case "copyediting":
        return setData(copyediting);
      case "projectmanagement":
        return setData(projectmanagement);
      case "journalproduction":
        return setData(journalproduction);
      case "bookproduction":
        return setData(bookproduction);
      case "graphics":
        return setData(graphics);
      case "peerreview":
        return setData(peerreview);
      case "ebooks":
        return setData(Ebooks);
      case "accessibility":
        return setData(Accessibility);
      case "contentdigitization":
        return setData(contentdigitization);
      case "contenttransformation":
        return setData(contenttransformation);
      case "contentconversion":
        return setData(contentConversion);
      case "healthops":
        return setData(healthops);
      default:
        return null;
    }
  };

  const schema = seoSchemas[services] || {};

  return (
    <>
      {/* <SEO
        title="Peer Review Services & XPERT Review Platform | Transforma Pvt Ltd"
        description="End-to-end peer review solutions with expert reviewer matching, manuscript tracking, AI-driven evaluation, and XPERT Review platform for faster and higher-quality academic publishing."
        keywords="peer review services, manuscript review, scholarly peer review, reviewer matching, XPERT Review, academic publishing, editorial review process, research publication support"
        canonical="https://www.transforma.in/content/peerreview"
        schema={peerReviewSchema}
      /> */}
      <SEO
        title={schema?.name || "Transforma Services"}
        description={schema?.description || ""}
        keywords={schema?.keywords || ""}
        // canonical={`https://www.transforma.in/content/${services}`}
        canonical={schema?.provider?.url}
        schema={schema}
      />
      <div className="w-full flex flex-col items-center ruler">
        {data ? (
          <>
            <Section1 data={data} />
            {!data.desc1 && firstPath == "digital" ? <Section2 data={data} /> : !data.desc1 ? <Sections2 data={data} path={services} /> : ""}
            {data.section2 ? <Section4 data={data.section2} /> : ""}
            {data.why ? <Section3 data={data} /> : ""}
            {data.desc1 ? <Section5 data={data} /> : ""}
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AllContent;
